import { render, staticRenderFns } from "./SafetyIncidentPanel.vue?vue&type=template&id=27637da8"
import script from "./SafetyIncidentPanel.vue?vue&type=script&lang=js"
export * from "./SafetyIncidentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports